import { Route, Routes, useNavigate } from "react-router-dom";
import Login from "./Components/Login/Login"
import useUser from "./hooks/useUser";
import BookingPage from "./Pages/BookingPage";
import DashboardPage from "./Pages/DashboardPage";
import DocumentPage from "./Pages/DocumentPage";
import EquipmentPage from "./Pages/EquipmentPage";
import EstimatePage from "./Pages/EstimatePage";
import HomePage from "./Pages/HomePage";
import InvoicePage from "./Pages/InvoicePage";
import LoginPage from "./Pages/LoginPage";
import MiscPage from "./Pages/MiscPage";
import ReportPage from "./Pages/ReportPage";
import SchedulePage from "./Pages/SchedulePage";
import WorkorderPage from "./Pages/WorkorderPage";

function App() {        
    
    return(  
      <div className='h-screen bg-slate-200 overflow-auto'>
        <div className=''>          
          <Routes>
            <Route path='/' element={<HomePage/>}/>
            <Route path='/dashboard' element={<DashboardPage/>}/>
            <Route path='/login' element={<LoginPage/>}/>
            <Route path='/workorder/addr_seq/:id' element={<WorkorderPage/>}/>            
            <Route path='/schedule/addr_seq/:id' element={<SchedulePage/>}/>            
            <Route path='/booking/addr_seq/:id' element={<BookingPage/>}/>            
            <Route path='/report/addr_seq/:id' element={<ReportPage/>}/>            
            <Route path='/invoice/status/:id' element={<InvoicePage/>}/>            
            <Route path='/equipment/addr_seq/:id' element={<EquipmentPage/>}/>            
            <Route path='/estimate/addr_seq/:id' element={<EstimatePage/>}/>                        
            <Route path='/misc' element={<MiscPage/>}/>                        
            <Route path='/misc/doc/:id' element={<DocumentPage/>}/>                        
          </Routes>                                 
        </div>  

      </div>
    )    
  }

  export default App
  